import { filter, find, unionBy } from 'lodash'

export const getAccessWays = ({ all }) => all

export const getActiveAccessWays = (state) => {
    return (id = null) => (id === '' || id === null) ? filter(state.all, { active: true }) : unionBy(filter(state.all, { active: true }), [find(state.all, { id })], 'id')
}

export const getInactiveAccessWays = (state) => {
    return filter(state.all, { active: false })
}



// WEBPACK FOOTER //
// ./src/modules/parameters/access_ways/store/getters.js